class CertOfCompRecord {
  constructor(data, config) {
    this.abstract = data.abstract
    this.acres = data.acres
    this.apiNumber = data.api_number
    this.approvalDate = data.approval_date
    this.block = data.block
    this.classification = data.classification
    this.county = data.county
    this.district = data.district
    this.fieldName = data.field_name
    this.formations = data.formations
    this.gatherers = data.gatherers
    this.leaseName = data.lease_name
    this.legal = data.legal
    this.nominators = data.nominators
    this.oldOperator = data.old_operator
    this.operator = data.operator
    this.operatorNumber = data.operator_number
    this.purchasers = data.purchasers
    this.purposeOfFiling = data.purpose_of_filing
    this.rrcGasIdOrLeaseNum = data.rrc_gas_id_or_lease_num
    this.section = data.section
    this.source = data.source
    this.sourceUrl = data.source_url
    this.state = data.state
    this.survey = data.survey
    this.typeOfDocument = data.type_of_document
    this.wellStatus = data.well_status
    this.wellType = data.well_type
  }
}

export default CertOfCompRecord
